import { render, staticRenderFns } from "./ReSearchCardStaffBigRoles.vue?vue&type=template&id=25acf526&scoped=true"
import script from "./ReSearchCardStaffBigRoles.vue?vue&type=script&lang=js"
export * from "./ReSearchCardStaffBigRoles.vue?vue&type=script&lang=js"
import style0 from "./ReSearchCardStaffBigRoles.vue?vue&type=style&index=0&id=25acf526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25acf526",
  null
  
)

export default component.exports